import getReducerHandler from '../../../../shared/helpers/getReducerHandler'

const ACTIONS = Object.freeze({
  INIT_KIOSK: 'INIT_KIOSK',
})

const kioskInitialState = {
  app: null,
  center: null,
  color: null,
  redirect: null,
  unauthRedirect: null,
  keyCodeUndockRedirect: null,
}

/*
 * --- INDIVIDUAL ACTION HANDLERS ---
 * (Set multiple values & merge/processing logic only, otherwise use handleReducerSimpleSetter)
 */

const handleInitKiosk = (state, action) => {
  return {
    ...state,
    ...action.data,
  }
}

// --- Handlers registry ---
const handlers = {
  [ACTIONS.INIT_KIOSK]: handleInitKiosk,
}

const kioskReducer = (state, action) => getReducerHandler(state, action, handlers)

export { kioskInitialState, kioskReducer, ACTIONS }
